import { render } from "./i-cep.vue?vue&type=template&id=9b30411e"
import script from "./i-cep.vue?vue&type=script&lang=js"
export * from "./i-cep.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__